import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-confirmation-reason',
    templateUrl: './confirmation-reason.component.html',
    styleUrls: ['./confirmation-reason.component.scss'],
    standalone: false
})
export class ConfirmationReasonComponent implements OnInit {

    public confirmationText: string;
    public code: string;
    public confirmButtonText;

    isConfirmed: boolean;
    reason : string;

    constructor() { }

    ngOnInit() {
    }

    onNo() {
        this.isConfirmed = false;
    }

    onYes() {
        this.isConfirmed = true;
    }

}
